import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  createUser,
  getUser,
  getUsers,
  editUser,
  deleteUser,
} from "api/userApi"

export const USERS_QUERY_KEY = "users"

export const useUsers = (params = {}) => {
  return useQuery({
    queryKey: [USERS_QUERY_KEY, params], // include params in the query key for caching
    queryFn: () => getUsers(params),
    keepPreviousData: true, // optional, useful for pagination or filtering
  })
}

export const useUser = identifier => {
  return useQuery({
    queryKey: [USERS_QUERY_KEY, identifier], // unique cache key
    queryFn: () => getUser(identifier),
    enabled: !!identifier, // only run if identifier is provided
  })
}

export const useCreateUser = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createUser,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([USERS_QUERY_KEY]) // refresh users list
      }
    },
  })
}

export const useEditUser = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: editUser,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([USERS_QUERY_KEY]) // refresh users list
      }
    },
  })
}

export const useDeleteUser = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteUser,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([USERS_QUERY_KEY]) // refresh users list
      }
    },
  })
}
